import React, { useState, useEffect } from "react";
import * as S from "./SearchModalStyle";
import { clientAdminService } from "../../Services/clientAdminService";
import { contractAdminService } from "../../Services/contractAdminService";
import { withdrawAdminService } from "../../Services/withdrawAdminService";
import { formatDate, formatNumber } from "../ASSETS/assets"; // Verifique caminho dos assets

export default function SearchModal({ type, onClose, onSelect }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (type === "contract" || type === "withdraw") {
      handleSearch();
    }
  }, []);

  const handleSearch = async () => {
    setLoading(true);
    try {
      let data;
      if (type === "client") {
        data = await clientAdminService.searchClients(20, 0, searchTerm);
        setResults(Array.isArray(data) ? data : data.clients || []);
      } else if (type === "contract") {
        data = await contractAdminService.searchContracts(
          20,
          0,
          "date_desc",
          "",
          searchTerm,
          ""
        );
        setResults(
          Array.isArray(data) ? data : data.contracts || data.results || []
        );
      } else if (type === "withdraw") {
        data = await withdrawAdminService.searchWithdraws(
          20,
          0,
          "desc",
          "",
          searchTerm
        );

        // --- CORREÇÃO AQUI ---
        // O JSON retorna { "withdraws": [...] }, adicionei a verificação data.withdraws
        setResults(
          Array.isArray(data) ? data : data.withdraws || data.withdrawals || []
        );
      }
    } catch (error) {
      console.error("Erro na busca:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const renderItem = (item) => {
    if (type === "client") {
      return (
        <S.ListItem
          key={item.id}
          onClick={() => onSelect({ id: item.id, name: item.name })}
        >
          <div className="info">
            <strong>{item.name}</strong>
            <span>CPF: {item.cpfCnpj}</span>
            <small>ID: {item.id}</small>
          </div>
          <div className="arrow">➔</div>
        </S.ListItem>
      );
    }

    if (type === "contract") {
      const contract = item.contract || item;
      return (
        <S.ListItem
          key={contract.id}
          onClick={() =>
            onSelect({
              id: contract.id,
              clientId: contract.clientId,
              clientName: item.clientName || "N/A",
            })
          }
        >
          <div className="info">
            <strong>Contrato #{contract.id}</strong>
            <span>Cliente: {item.clientName || "N/A"}</span>
            <span>Valor: R$ {formatNumber(contract.totalPrice)}</span>
            <small>Data: {formatDate(contract.dateCreated)}</small>
          </div>
          <div className="arrow">➔</div>
        </S.ListItem>
      );
    }

    if (type === "withdraw") {
      const withdraw = item.withdraw || item;
      return (
        <S.ListItem
          key={withdraw.id}
          onClick={() =>
            onSelect({
              id: withdraw.id,
              clientId: withdraw.clientId,
              contractId: withdraw.contractId,
              clientName: item.clientName,
            })
          }
        >
          <div className="info">
            <strong>Saque #{withdraw.id}</strong>
            <span>Cliente: {item.clientName || "N/A"}</span>
            <span>Valor: R$ {formatNumber(withdraw.amountWithdrawn)}</span>
            <small>Ref. Contrato #{withdraw.contractId || "Indicação"}</small>
          </div>
          <div className="arrow">➔</div>
        </S.ListItem>
      );
    }
  };

  const getTitle = () => {
    if (type === "client") return "Selecionar Cliente";
    if (type === "contract") return "Selecionar Contrato";
    return "Selecionar Saque";
  };

  return (
    <S.Overlay>
      <S.Modal>
        <S.Header>
          <h3>{getTitle()}</h3>
          <button onClick={onClose}>&times;</button>
        </S.Header>
        <S.SearchBar>
          <input
            placeholder="Digite para buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleSearch()}
          />
          <button onClick={handleSearch}>Buscar</button>
        </S.SearchBar>
        <S.List>
          {loading ? (
            <S.Empty>Carregando...</S.Empty>
          ) : results.length > 0 ? (
            results.map(renderItem)
          ) : (
            <S.Empty>Nenhum resultado encontrado.</S.Empty>
          )}
        </S.List>
      </S.Modal>
    </S.Overlay>
  );
}
